<template>
  <el-card>
    <el-collapse :value="['1', '2']">
      <el-collapse-item name="1">
        <template slot="title">
          <div class="collapse-title">基本信息</div>
        </template>
        <el-form ref="workerInfo" class="global-form2 form-flex" :model="workerInfo" :rules="rules" label-position="right"
                 label-width="130px">
          <div class="block">
            <el-form-item label="身份证照片" prop="workerCardUp">
              <template slot="label">
            <p>身份证人像面<br><span class="label-tip">(自动识别身份信息)</span></p>
              </template>
              <div v-if="workerInfo.workerCardUp" class="imgBlock">
                <el-image
                  :src="workerInfo.workerCardUp"
                  :preview-src-list="[workerInfo.workerCardUp]"
                  fit="fill">
                </el-image>
                <span></span>
                <i class="el-icon-close" @click="imgRemove('workerCardUp')"></i>
              </div>
              <UploadFile @onSuccess="onSuccess1" :slotShow='true' v-else>
                <template>
                  <i class="el-icon-plus"></i>
                  <p>上传照片</p>
                </template>
              </UploadFile>
            </el-form-item>
            <el-form-item label="身份证国徽面" prop="workerCardDo">
              <div v-if="workerInfo.workerCardDo" class="imgBlock">
                <el-image
                  :src="workerInfo.workerCardDo"
                  :preview-src-list="[workerInfo.workerCardDo]"
                  fit="fill">
                </el-image>
                <span></span>
                <i class="el-icon-close" @click="imgRemove('workerCardDo')"></i>
              </div>
              <UploadFile @onSuccess="onSuccess2" :slotShow='true' v-else>
                <template>
                  <i class="el-icon-plus"></i>
                  <p>上传照片</p>
                </template>
              </UploadFile>
            </el-form-item>
          </div>
          <div class="block">
            <el-form-item label="姓名" prop="workerName">
              <el-input v-model="workerInfo.workerName" placeholder="请输入姓名" maxlength="50"></el-input>
            </el-form-item>
            <el-form-item label="身份证号" prop="workerCard">
              <el-input v-model="workerInfo.workerCard" placeholder="请输入证件号码" maxlength='18' @change='workerCardChange'></el-input>
            </el-form-item>
            <el-form-item label="性别" prop="workerSex">
              <el-radio-group v-model="workerInfo.workerSex">
                <el-radio border v-for="(item,index) in sexList" :key="index" :label="item.dicCode">{{item.dicValue}}</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="家庭住址" prop="homeAddress">
              <el-input v-model="workerInfo.homeAddress" placeholder="请输入地址" maxlength='50'></el-input>
            </el-form-item>
            <el-form-item label="手机号码" prop="workerMobile">
              <el-input v-model="workerInfo.workerMobile" placeholder="请输入号码" maxlength='11'></el-input>
            </el-form-item>
          </div>
          <div class="block">
            <el-form-item label="工人照片" prop="workerImg">
              <div v-if="workerInfo.workerImg" class="imgBlock">
                <el-image
                  :src="workerInfo.workerImg"
                  :preview-src-list="[workerInfo.workerImg]"
                  fit="fill">
                </el-image>
                <span></span>
                <i class="el-icon-close" @click="imgRemove('workerImg')"></i>
              </div>
              <UploadFile @onSuccess="onSuccess3" :slotShow='true' v-else>
                <template>
                  <i class="el-icon-plus"></i>
                  <p>上传照片</p>
                </template>
              </UploadFile>
            </el-form-item>
          </div>
        </el-form>
      </el-collapse-item>
      <el-collapse-item name="2">
        <template slot="title">
          <div class="collapse-title">其他信息</div>
        </template>
        <el-form ref="workerInfo" class="global-form2" :model="workerInfo" :rules="rules" label-position="right"
                 label-width="130px">
          <el-form-item label="所属项目" prop="projectId">
            <el-select v-model="workerInfo.projectId" placeholder="请选择项目" filterable>
              <el-option v-for="(item,index) in normalProjectList" :key="index" :label="item.projectName" :value="item.projectId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="劳务模式" prop="laborModel">
            <el-radio-group v-model="workerInfo.laborModel">
              <el-radio label="1">包月</el-radio>
              <el-radio label="2">点工</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="劳务单价" prop="laborPrice">
            <el-input placeholder="请输入内容" v-model="workerInfo.laborPrice">
              <template slot="append">{{ workerInfo.laborModel === '1' ? '元/月' : '元/天' }}</template>
            </el-input>
          </el-form-item>
          <el-form-item label="工种" prop="workType">
            <el-select v-model="workerInfo.workType" placeholder="请选择工种" clearable>
              <el-option v-for="(item,index) in workTypeList" :key="index" :label="item.dicValue" :value="item.dicCode"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="紧急联系人" prop="emergencyPerson">
            <el-input v-model="workerInfo.emergencyPerson" placeholder="请输入姓名" maxlength="50"></el-input>
          </el-form-item>
          <el-form-item label="联系人号码" prop="emergencyPersonMobile">
            <el-input v-model="workerInfo.emergencyPersonMobile" placeholder="请输入号码" maxlength='11'></el-input>
          </el-form-item>
        </el-form>
      </el-collapse-item>
    </el-collapse>
    <div class="mt20">
      <el-button type="primary" @click="submitForm" :disabled="isAdding">保存</el-button>
      <el-button @click="goBack">取消</el-button>
    </div>
  </el-card>
</template>

<script>
import { analyzeIDCard } from '@/utils/formatData'
import { idCardNo, phone, validateInteger } from '@/utils/validate'
import UploadFile from '@/components/uploadFile/Index.vue'

export default {
  name: 'projectWorkerAdd',
  components: { UploadFile },
  data () {
    return {
      isAdding: false,
      workTypeList: [],
      sexList: [],
      workerInfo: {
        workerCardUp: '',
        workerCardDo: '',
        workerName: '',
        workerCard: '',
        workerSex: '',
        homeAddress: '',
        workerMobile: '',
        workerImg: '',
        projectId: '',
        workType: '',
        emergencyPerson: '',
        emergencyPersonMobile: '',
        laborModel: '1',
        laborPrice: ''
      },

      rules: {
        workerName: [
          { required: true, message: '请输入姓名', whitespace: true }
        ],
        workerCard: [
          { required: true, message: '请输入身份证号码', trigger: 'change' },
          { validator: idCardNo }
        ],
        workerSex: [
          { required: true, message: '请选择性别', trigger: 'change' }
        ],
        mobile: [
          { validator: phone }
        ],
        projectId: [
          { required: true, message: '请选择项目', trigger: 'change' }
        ],
        emergencyPersonMobile: [
          { validator: phone }
        ],
        laborPrice: [
          { validator: validateInteger }
        ]
      }
    }
  },
  computed: {
    workerId () {
      return this.$route.params.workerId || ''
    },
    normalProjectList () {
      return this.$store.state.projectList
    }
  },

  created () {
    this.getDicList()
    this.getSexList()
    if (this.workerId) {
      this.getWorkerInfo()
    }
  },
  methods: {
    getWorkerInfo () {
      this.$axios.get(this.$apis.worker.selectYhWorkerByWorkerIdJg, {
        workerId: this.workerId
      }).then(res => {
        this.workerInfo = res || {}
      })
    },

    // 工种
    getDicList () {
      this.$axios.get(this.$apis.common.selectDicByList, { dicType: 'workType' }).then(res => {
        this.workTypeList = res.workType || []
      })
    },

    // 性别
    getSexList () {
      this.$axios.get(this.$apis.common.selectDicByList, { dicType: 'workerSex' }).then(res => {
        this.sexList = res.workerSex || []
      })
    },

    workerCardChange (val) {
      const obj = analyzeIDCard(val)
      this.workerInfo.workerSex = obj.sex
    },

    // 文件上传身份证上面成功返回
    onSuccess1 (file) {
      const fileUrl = file.filePrefix + file.fileUrl
      this.$axios.post(this.$apis.worker.ocrCard, {
        workerCardUp: fileUrl
      }).then((res) => {
        this.workerInfo.workerName = res.workerName || ''
        this.workerInfo.workerSex = res.workerSex || ''
        this.workerInfo.workerCard = res.workerCard || ''
        this.workerInfo.homeAddress = res.homeAddress || ''
        this.workerInfo.workerCardUp = res.workerCardUp || ''
      }).catch(() => {
        // ...
      })
    },

    // 文件上传身份证反面成功返回
    onSuccess2 (file) {
      this.workerInfo.workerCardDo = file.filePrefix + file.fileUrl
    },

    // 文件上传工人照片成功返回
    onSuccess3 (file) {
      const fileUrl = file.filePrefix + file.fileUrl
      this.$axios.post(this.$apis.worker.detectFaceImg, {
        workerImg: fileUrl
      }).then(() => {
        this.workerInfo.workerImg = fileUrl
      }).catch(() => {
        // ...
      })
    },

    // 照片删除
    imgRemove (str) {
      this.workerInfo[str] = ''
    },

    submitForm () {
      this.$refs.workerInfo.validate(valid => {
        if (valid) {
          this.isAdding = true
          const url = this.workerId ? this.$apis.worker.updateYhWorker : this.$apis.worker.insertYhWorker
          this.$axios.post(url, this.workerInfo).then(() => {
            this.$message.success(this.workerId ? '修改成功' : '添加成功')
            this.goBack()
          }).finally(() => {
            this.isAdding = false
          })
        }
      })
    },

    goBack () {
      this.$router.push({ path: '/laborManageList/worker' })
    }

  }

}
</script>

<style scoped lang="scss">
  @import "@/assets/scss/color";
  .form-flex {
    display: flex;
    flex-wrap: wrap;
  }
  .label-tip{
    font-size: 12px;
    color: #999999;
  }

  .imgBlock {
    position: relative;
    height: 104px;
    width: 104px;
    margin-right: 10px;
    border-radius: 2px;
    .el-image,img{
      width:100%;
      height: 100%;
    }

    span {
      position: absolute;
      top: 0;
      right: 0;
      width: 0px;
      height: 0px;
      border-top: 34px solid $color-default;
      border-left: 34px solid transparent;
    }

    i {
      transition: all 0.3s;
      position: absolute;
      top: 3px;
      right: 3px;
      font-size: 15px;
      color: #ffffff;
      cursor: pointer;
    }
    i:hover {
      color: #ffffff98;
    }
  }
  ::v-deep .el-upload--picture-card{
    width: 104px;
    height: 104px;
    line-height: 26px;
    padding:25px 10px;
  }
</style>
